var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.isDashboardLoaded)?[(_setup.dashboardSetting?.value === 'slp')?_c('div',[_c(_setup.LessonDashBoard)],1):_c('div',[_c(_setup.DefaultDashBoard)],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }